import { EventEmitter, Injectable, Output } from '@angular/core';
import { ChatErrorService } from './chat-error.service';
import { ChatEmojis, ChatFile } from '../model/attchment-chat.modal';
import { DropDownService } from './dropdown.service';
import { AuthService } from './auth.service';
import { SystemUser } from '../model/user-interfaces';
import { ApiService } from './api.service';
import { VariableService } from './variable.service';
import { Attachment, ChatMessage, CHatUserMentioned, MessageCustomOptions } from '../model/chat.message';
import { environment } from 'src/environments/environment';
import { GET_FILE_NAME_AND_REMOVE_EXTENSION } from '../helpers/chat-helpers.cont';
import { ChatDataGroupingService } from './chat-data-grouping.service';
import { GET_IMAGE_DIMENSION_FROM_BASE64, MSG_MAX_LENGTH, PREVIEW_SM_MAZ_SIZE } from 'src/app/constants/constants';
import { StateChange } from 'ng-lazyload-image';
@Injectable({
  providedIn: 'root'
})
export class ChatCommonService {
  msOfficeFileTypes = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'xla', 'txt', 'sheet'];
  wordExtensions = ["doc", "docx", "dot", "dotx"];
  excelExtensions = ["xls", "xla", "xlsx", "xlsm", "xlt", "xltx"];
  pptExtensions = ["ppt", "pptx", "pptm", "pot", "potx", "pps", "ppsx"];
  btnsAlign = "center";
  Emojis: ChatEmojis = {
    "Thumbs Up": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/refs/heads/master/Emojis/Hand%20gestures/Thumbs%20Up.png",
    "Red Heart": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Red%20Heart.png",
    "Beaming Face with Smiling Eyes": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/refs/heads/master/Emojis/Smilies/Beaming%20Face%20with%20Smiling%20Eyes.png",
    "Face with Tongue": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Face%20with%20Tongue.png",
    "Crying Face": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Crying%20Face.png",
    "Thinking Face": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/refs/heads/master/Emojis/Smilies/Thinking%20Face.png",
    "Face with Open Mouth": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Smilies/Face%20with%20Open%20Mouth.png",
    "Thumbs Down": "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/refs/heads/master/Emojis/Hand%20gestures/Thumbs%20Down.png"
  };

  // Word Document (.doc, .docx)
  wordDocRegex = /\.(doc|docx)$/i;
  // Excel Workbook (.xls, .xlsx, .xlsm, .xlsb)
  excelWorkbookRegex = /\.(xls|xlsx|xlsm|xlsb)$/i;
  // PowerPoint Presentation (.ppt, .pptx)
  powerPointRegex = /\.(ppt|pptx)$/i;
  // Access Database (.accdb, .mdb)
  accessDatabaseRegex = /\.(accdb|mdb)$/i;
  // Comma-Separated Values (.csv)
  csvRegex = /\.csv$/i;
  // Tab-Separated Values (.tsv)
  tsvRegex = /\.tsv$/i;
  // Plain Text (.txt)
  textRegex = /\.txt$/i;
  // Google Sheets (.sheet)
  googleSheetsRegex = /\.sheet$/i;
  //ms office file
  msOfficeFileRegex = /\.(docx?|doc?|pptx?|xls?|xlsx?)$/i;
  showReply = false;
  urlPreview = false;
  unreadMessagesCount = 0;
  isDragging = false;
  // selectedFile: ChatFile = null;
  // images: ChatFile[] = [];

  constructor(
    private chatErrorService: ChatErrorService,
    private dropDownService: DropDownService,
    private authService: AuthService,
    private apiService: ApiService,
    private vars: VariableService,
    private chatDataGroupingService: ChatDataGroupingService,
  ) {
  }


  isExceFile(fileName: string): boolean {
    return this.csvRegex?.test(fileName) || this.excelWorkbookRegex?.test(fileName);
  }

  // Check if a file is a TSV
  isTSV(fileName: string): boolean {
    return this.tsvRegex?.test(fileName);
  }

  // Check if a file is a plain text file
  isTextFile(fileName: string): boolean {
    return this.textRegex?.test(fileName);
  }

  // Check if a file is a Google Sheets file
  isGoogleSheetsFile(fileName: string): boolean {
    return this.googleSheetsRegex?.test(fileName);
  }

  //isMSword File
  isMsWordFile(filename: string): boolean {
    return this.wordDocRegex?.test(filename);
  }

  // Check if a file is a MS Office Sheets file
  isMsOfficeFile(fileName: string): boolean {
    return (this.msOfficeFileRegex?.test(fileName) || this.csvRegex?.test(fileName) || this.excelWorkbookRegex?.test(fileName));
  }

  async onPaste(e: any) {
    const clipboardData = e.clipboardData || window['clipboardData'];
    const hasText = clipboardData?.types?.includes('text/plain');
    if (hasText) {
      return;
    }
    this.urlPreview = false;
    const items: DataTransferItemList = (e.clipboardData || e.originalEvent.clipboardData).items;
    // Convert the items to an array and filter out null values
    const filesArray = Array.from(items)
      .map(item => item.getAsFile())
      .filter(file => file !== null) as File[];
    // Transform the array into an object with filenames as keys
    const filesObject: { [key: string]: File } = {};
    await filesArray.forEach(file => {
      filesObject[file.name] = file;
    });
    if (filesArray.length) {
      e.preventDefault();
    }
    this.onFilesChanges(filesObject);
    return !!filesArray?.length;
  }

  isDuplicateFile(file: File, filesList): boolean {
    return filesList?.some(existingFile => existingFile?.name == file?.name);
  }

  transformUserName(userName: any): string {
    let fullUserName = userName ? userName?.split('_') : 'TechbarUser';
    return fullUserName[0];
  }

  onFilesChanges(fileList: { [key: string]: File }, clear = false) {
    try {
      this.isDragging = false;
      let videosCount = 0;
      this.vars.images = [];
      for (const key in fileList) {
        const error = { message: "" };
        let maxLimitReached = false;
        if (fileList.hasOwnProperty(key)) {
          const myFile: File = fileList[key];
          // console.log('myFile', myFile);
          let isValid = false;
          let _title = GET_FILE_NAME_AND_REMOVE_EXTENSION(myFile?.name);
          const fileSize = myFile.size;
          if (!fileSize) {
            error.message = "no_content_file";
            this.chatErrorService.showError(error);
            continue;
          }
          if (this.vars.images.length > 15 || maxLimitReached) {
            throw new Error("maxLimit");
          }
          else if ((fileSize / (1024 * 1024)) > 25) {
            error.message = "maxSize";
            this.chatErrorService.showError(error);
            continue;
          }
          if (!this.isDuplicateFile(myFile, this.vars.images)) {
            const fileType = myFile?.type;
            const fileExtension = myFile.name.split('.').pop()?.toLowerCase();

            if (fileType.includes('pdf')) {
              isValid = true;
              const reader = new FileReader();
              reader.onload = (e) => {
                const pdf: ChatFile = {
                  loading: true,
                  name: myFile?.name,
                  type: myFile?.type,
                  src: e?.target?.result as any,
                  lastModified: myFile?.lastModified,
                  size: fileSize,
                  description: "",
                  title: _title,
                  file: myFile,
                  mentions: [],
                  fileExtension: fileExtension,
                  rid: this?.generateRandomString(25, this.vars.roomId, this.uId)
                };

                if (this.vars.images.length > 15) {
                  this.chatErrorService.showError({ message: "maxLimit" });
                  maxLimitReached = true;
                }
                else {
                  this.vars.images.push(pdf);
                  this.vars.pdfs.push(pdf);
                }
                this.setPreview();
                this.sendData();
                // this.scrollAndDetectChanges();
              };
              reader.readAsArrayBuffer(myFile);
            }

            const isMsOfficeFile = this.chatDataGroupingService?.isMsOfficeFile(myFile.name);
            if (isMsOfficeFile || fileType.includes('text') || fileType.includes('txt')
              || fileType.includes('json') || fileType.includes('zip') || fileType === '') {
              isValid = true;
              const officeFile: ChatFile = {};
              officeFile.file = myFile;
              officeFile.description = "";
              officeFile.title = _title;
              officeFile.mentions = [];
              officeFile.type = myFile?.type;
              officeFile.name = myFile?.name;
              officeFile.rid = this.generateRandomString(25, this.vars.roomId, this.uId);
              officeFile.size = fileSize;
              officeFile.fileExtension = fileType == '' ? "file" : fileExtension;
              if (this.vars.images.length > 14) {
                this.chatErrorService.showError({ message: "maxLimit" });
                maxLimitReached = true;
              }
              else {
                this.vars.images.push(officeFile);
              }
              // if (!this.filePreview) {
              //   // this.vars.images[0].description = this.messageInput?.slice(0, 1024);
              //   this.setPreview();
              //   this.sendData();
              // }
            }

            if (fileType.includes('audio')) {
              isValid = true;
              const audioFile: ChatFile = {};
              audioFile.file = myFile;
              audioFile.type = myFile?.type
              // audioFile.src = myFile;
              audioFile.title = _title;
              audioFile.mentions = [];
              audioFile.rid = this.generateRandomString(25, this.vars.roomId, this.uId);
              audioFile.name = myFile?.name;
              audioFile.size = fileSize;
              audioFile.fileExtension = fileExtension;
              const reader = new FileReader();
              reader.onload = async (event) => {
                audioFile.src = reader.result as string;
                let audioData = await this.chatDataGroupingService?.getAudioDuration(myFile);
                // console.log('audioData', audioData);
                if (audioData?.duration) {
                  audioFile.duration = audioData.duration;
                  if (this.vars.images.length > 14) {
                    this.chatErrorService.showError({ message: "maxLimit" });
                  }
                  else {
                    this.vars.images.push(audioFile);
                    maxLimitReached = true;
                  }
                  this.setPreview();
                  this.sendData();
                }
                else {
                  this.displayError('Can not send file with duration less than 1 second.');
                }
              };
              reader.readAsDataURL(myFile);
            }

            const isImage = fileType?.includes('image');
            const isVideo = fileType?.includes('video');
            if (isImage || isVideo) {
              if (isVideo) {
                videosCount += 1;
              }
              if (videosCount > 3) {
                error.message = "max_video_limit";
                this.chatErrorService.showError(error);
                continue;
              }
              //check if video is not mp4
              if (isVideo && !myFile?.name?.endsWith('.mp4')) {
                error.message = "unsupported_video_format";
                this.chatErrorService.showError(error);
                continue;
              }
              else {
                isValid = true;
                let isFileOk = true;
                const reader = new FileReader();
                reader.onload = async (event: any) => {
                  let previewSm = '';
                  const res = event.target.result as string;
                  const file: ChatFile = {
                    name: myFile?.name,
                    src: res,
                    type: myFile?.type,
                    lastModified: myFile?.lastModified,
                    size: fileSize,
                    description: "",
                    mentions: [],
                    title: _title,
                    previewSm: previewSm,
                    file: myFile,
                    fileExtension: fileExtension,
                    rid: this.generateRandomString(25, this.vars.roomId, this.uId),
                    isSvg: myFile?.name?.endsWith('.svg') ? true : false
                  };
                  // console.log('file', file);
                  if (isFileOk) {
                    if (this.vars.images.length > 14) {
                      this.chatErrorService.showError({ message: "maxLimit" });
                      maxLimitReached = true;
                    }
                    else {
                      this.vars.images.push(file);
                      if (isImage) {
                        this.updateImageFilePreviewSm(file.rid, res, myFile);
                      }
                      if (isVideo) {
                        // this.updateVideoPreviews(myFile, res, file.rid);
                      }
                    }
                    this.setPreview();
                    this.sendData();
                  }
                };
                reader.readAsDataURL(myFile);
              }
              // If file type is not supported
            }
            if (!isValid && error?.message != "unsupported_video_format") {
              error.message = "unsupported_file";
              this.chatErrorService.showError(error);
              continue;
            }
          }
          else {
            this.displayError('File already selected ');
          }
        }
        if (maxLimitReached) {
          break;
        }
        // if (!this.previewOpened) {
        //   this.previewOpened = true;
        // }
      }
      // console.log('images array after files selection', this.vars.images);
      this.chatErrorService.resetErrorsRegisters();
    } catch (error) {
      let text = "";
      if (error?.message === "maxLimit") {
        text = 'You can select up to 15 files.';
      }
      else if (error?.message) {
        text = error?.message;
      }
      this.displayError(text);
    }
  }

  setPreview() {

  }
  sendData() {

  }

  async updateImageFilePreviewSm(rid: string, src: string, file: File) {
    let dimensions = await GET_IMAGE_DIMENSION_FROM_BASE64(src)
    let fileIndex = this.vars.images.findIndex(file => file?.rid == rid);
    if (fileIndex != -1) {
      const previewSmData = await this.chatDataGroupingService?.reduceSize(src, 0.9, PREVIEW_SM_MAZ_SIZE);
      if (previewSmData?.data) {
        this.vars.images[fileIndex].previewSm = previewSmData.data;
      }
      if (dimensions?.width && dimensions?.height) {
        this.vars.images[fileIndex].width = dimensions.width;
        this.vars.images[fileIndex].height = dimensions.height;
      }
    }
  }


  uploadFileToS3(formData: FormData): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        this.apiService?.uploadFileToS3(formData).subscribe((res: { Location: string }) => {
          console.log('uploadFileToS3 res', res);
          resolve(res?.Location ?? '');
        },
          (error) => {
            resolve('')
          }
        )
      } catch (error) {
        resolve('')
      }
    });
  }

  toggleReadMore(msg: ChatMessage, event: Event, starMode = false) {
    if (starMode) {
      // msg.showCharLimit = 500;
      event.preventDefault();
      event.stopPropagation();
    }
    if (!msg?.msg) {
      msg.msg = msg?.description
    }
    const messageLength = msg.msg.length;
    if (msg.showCharLimit < 500) {
      msg.showCharLimit = 500;
    }
    if (msg.showCharLimit < MSG_MAX_LENGTH && msg.showCharLimit < messageLength) {
      msg.showCharLimit += 1000;

      if (msg.showCharLimit > messageLength) {
        msg.showCharLimit = messageLength;
      }
      if (msg.showCharLimit >= MSG_MAX_LENGTH) {
        msg.showCharLimit = MSG_MAX_LENGTH;
      }
    }
    else {
      msg.showCharLimit = 500; // Collapse back to default 500 characters
    }
    msg.expanded = msg.showCharLimit < messageLength && msg.showCharLimit < MSG_MAX_LENGTH;
  }

  displayError(msg: string, type = 'error') {
    this.chatErrorService.showError({ message: msg }, type);
  }


  postChatFiles(formData: FormData) {
    this.apiService.postChatFiles(formData).subscribe(
      (res: any) => {
      },
      (err) => {
        this.displayError(err?.error.error ?? 'An error occurred while uploading file');
        console.log('postChatFiles err', err);
      }
    );
  }

  get uId() {
    return this.myUid();
  }

  myUid(): number {
    return localStorage?.getItem(environment.X_User_Id) ? +JSON.parse(localStorage?.getItem(environment.X_User_Id)) : null;
  }

  generateRandomString(length: number, roomId: number, uId: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }
    let date = new Date();
    result = '' + roomId + '/' + uId + '/' + date?.toISOString() + '/' + result;
    return result;
  }

  //to check the key passed in the arrayData  
  hasIncluded(arrayData: any[], property: string, key: any): boolean {
    try {
      // let key1 = localStorage.getItem('key111');
      // let log = false;
      // if (key == key1) {
      //   log = true;
      // }
      if (!arrayData?.length || !key || !property) {
        return false;
      }
      return arrayData?.some((obj: any) => obj && obj[property] == key);
      // if(log){
      //   console.log('messageId key exist',exist)
      // }
      // return exist;
    } catch (error) {
      console.log('error', error);
    }
  }

  reduceSize(base64: string, quality: number, MAX_SIZE: number): Promise<{ data: string; error?: string }> {
    return new Promise(async (resolve, reject) => {
      try {
        const base64Length = (base64: string) =>
          (base64.length - 'data:image/jpeg;base64,'.length) * 3 / 4;
        while (base64Length(base64) > MAX_SIZE && quality > 0) {
          base64 = await this.scaleDownBase64Image(base64, 0.5);
          quality -= 0.1; // Reduce quality by 10% each time
        }
        resolve({ data: base64 });
      } catch (error) {
        resolve({ data: "", error: error?.message ?? error });
      }
    });
  }


  scaleDownBase64Image(base64: string, scale: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const scaledWidth = img.width * scale;
        const scaledHeight = img.height * scale;

        canvas.width = scaledWidth;
        canvas.height = scaledHeight;

        context?.drawImage(img, 0, 0, scaledWidth, scaledHeight);

        const scaledBase64 = canvas.toDataURL('image/png');
        resolve(scaledBase64);
      };

      img.onerror = (error: any) => {
        console.log('scaleDownBase64Image error', error);
        reject(`Error scaling image: ${error?.message}`);
      };
    });
  }

  parsify(options: any): MessageCustomOptions {
    if (typeof options == 'string' && options) {
      return JSON.parse(options);
    }
    return options ?? {};
  }

  createUserMessage(messageText: string, paramsObj, msgData, is_file?: boolean, mentionedUsers: CHatUserMentioned[] = []) {
    const tempId: string = paramsObj.tmid ? paramsObj.tmid : msgData?.tmid;
    let message: ChatMessage = {
      id: tempId,
      authorId: this.myUid(),
      roomId: this.vars.roomId,
      msg: messageText,
      delivered: false,
      seen: false,
      tempLoader: false,
      loading: true,
      type: "TEXT",
      options: paramsObj?.options ?? {},
      message_type: null,
      createdAt: new Date(),
      updatedAt: new Date(),
      description: paramsObj?.description ?? "",
      title: paramsObj?.title ?? "",
      files: [],
      status: 'pending',
      ts: new Date(),
      tmid: tempId,
      mentions: [

        {

          "userId": 275404918260508,

          "type": "mention",

          "username": "haris abbas"

        }

      ],

      md: [],
      // u: {
      //   id: this.uId,
      //   username: 'my_username'
      // }
    };

    if (!msgData) {
      msgData = {};
    }
    if (!paramsObj) {
      paramsObj = {};
    }
    if (!msgData?.options) {
      msgData.options = {};
    }
    if (!paramsObj?.options) {
      paramsObj.options = {};
    }

    message.attachments = paramsObj?.attachments ?? [];
    message.attachments_BE = [];

    if (msgData?.reply || paramsObj?.reply) {
      message.reply = paramsObj?.reply ?? msgData?.reply;
      message.replyId = paramsObj?.replyId ?? msgData?.replyId;
      message.parentId = paramsObj?.parentId ?? msgData?.parentId;
    }
    if (mentionedUsers?.length) {
      msgData.mentions = mentionedUsers;
      paramsObj.mentions = mentionedUsers;
    }

    // if (!is_file && messageText?.length && this.isEmoji(messageText)) {
    //   msgData.options.is_emoticon = true;
    //   paramsObj.options.is_emoticon = true;
    // }
    return { message, paramsObj, msgData };
  }

  //function to check for ms office file or pdf or text or video file in s3 link case
  isOfficeFile(msg: ChatMessage) {
    if (!msg?.attachments?.length || msg?.attachments?.length > 1) {
      return false;
    }
    let type: string = (msg?.options as MessageCustomOptions)?.fileExtension?.toLowerCase();
    if (this.wordExtensions?.includes(type)
      || this.excelExtensions?.includes(type)
      || this.pptExtensions?.includes(type)
      || type?.includes('pdf')
      || type?.includes('txt')
      || type?.includes('text')
      || type?.includes('txt')
      || type?.includes('csv')
      || type?.includes('json')
      || type?.includes('zip')
      || msg?.attachments[0].video_url
      || type == "file"
    ) {
      return true;
    }
    return false;
  }

  async downloadFile(file: Attachment, format = '', loading = false, index = -1) {
    try {
      if (loading == true) {
        return;
      }
      if (file.loading) {
        return;
      }
      if (file?.downloading) {
        file.downloading = false;
        file.downloadingCancelled = true;
        return;
      }

      // if (file?.attachments_BE?.length) {
      //   file = file?.attachments_BE[0];
      // }
      // if (file?.attachments?.length) {
      //   file = file?.attachments[0];
      // }
      let fileData = this.chatDataGroupingService.getAnchorDownloadLink(file, format);
      if (!fileData) {
        this.displayError('File format not supported. Report this error', 'error');
        return;
      }
      const ext = file?.options?.fileExtension ?? format;
      if (!ext) {
        this.displayError('File extension not supported. Report this error', 'error');
        return;
      }

      fileData.format = ext ? ext : (format ?? fileData?.format);
      fileData.title = file?.title ?? fileData?.title;
      let blob: Blob;
      let blobFromBase64: Blob;
      if (file?.base64) { //image file
        blobFromBase64 = this.chatDataGroupingService.dataURItoBlob(file?.base64, ext, fileData?.title);
      }
      else if (file?.videoFileBaseSrc64) {
        blobFromBase64 = this.chatDataGroupingService.dataURItoBlob(file?.videoFileBaseSrc64, ext, fileData?.title);
      }
      if (!blobFromBase64) {
        let fileUrl: string = fileData?.url;
        if (!fileUrl) {
          return this.displayError("Unsupported URL or file format");
        }
        file.downloading = true;
        file.downloaded = false;

        if (file?.blob) {
          blob = file.blob;
        }
        else {
          blob = await this.getFileAsBlob(fileUrl);
          file.blob = blob;
          file.base64 = await this.chatDataGroupingService.convertBlobToBase64(blob);
          // if (index > 0) {
          //   this.dataOut.emit({
          //     action: 'blob_file_base64',
          //     data: {
          //       base64: file.base64,
          //       index: index
          //     }
          //   });
          // }
        }
        if (file?.downloadingCancelled) {
          this.resetFileLoaders(file);
          return;
        }
      }
      else {
        blob = blobFromBase64;
      }

      if (blob) {
        // let extension = this.chatDataGroupingService.getFileExtension(fileData?.format) ?? 'png';
        const fileName = fileData?.title ?? 'Chat File';
        const isDateIncludedBefore = this.containsDateFormat(fileData?.title);
        const formattedDate = this.chatDataGroupingService.formatDateToString(new Date());
        let fullFileName = '';
        if (isDateIncludedBefore) {
          fullFileName = (`${this.removeTextAfterAt(fileName)} ${formattedDate}.${fileData.format}`)?.trim();
        }
        else
          fullFileName = (`${fileName} ${formattedDate}.${fileData.format}`)?.trim();

        // Create a blob URL
        const blobUrl = window.URL.createObjectURL(blob);

        // Create a link element
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fullFileName;
        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);

        file.downloading = false;
        file.downloaded = true;
      } else {
        throw new Error("Failed to fetch the file blob");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      this.displayError("An error occurred while downloading the file.");
      this.resetFileLoaders(file);
    }
  }

  getFileAsBlob(url: string): Promise<Blob> { // Return a Promise<any>
    try {
      return new Promise((resolve, reject) => {
        this.apiService.getFileAsBlob(url).subscribe(
          (blob) => {
            console.log('getFileAsBlob blob', blob);
            if (blob) {
              resolve(blob);
            }
            else {
              resolve(null)
            }
          },
          (error) => {
            console.log('getFileAsBlob error', error);
            resolve(null)
          }
        );

      });
    } catch (error) {
    }
  }


  resetFileLoaders(file: Attachment) {
    file.downloading = false;
    file.downloaded = false;
    file.downloadingCancelled = false;
  }

  containsDateFormat(input: string): boolean {
    if (!input) {
      return false;
    }
    const datePatterns = [
      /\b\d{4}-\d{2}-\d{2}\b/, // YYYY-MM-DD
      /\b\d{2}\/\d{2}\/\d{4}\b/, // DD/MM/YYYY or MM/DD/YYYY
      /\b\d{2}-\d{2}-\d{4}\b/, // MM-DD-YYYY
      /\b(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{1,2}, \d{4}\b/, // Month DD, YYYY
      /\b\d{1,2} (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{4}\b/, // DD Month YYYY
    ];

    return datePatterns.some((pattern) => pattern.test(input));
  }

  removeTextAfterAt(input: string): string {
    return input.replace(/\bat\b.*/, "").trim();
  }

  onStateChange(event: StateChange, object = null, image: HTMLElement = null) {
    try {
      switch (event.reason) {
        case 'setup'://The lib has been instantiated but we have not done anything yet.
          break;
        case 'observer-emit':
          // The image observer (intersection/scroll/custom observer) has emit a value so we
          // should check if the image is in the viewport.
          // `event.data` is the event in this case.
          break;
        case 'start-loading':// The image is in the viewport so the image will start loading
          break;
        case 'mount-image':// The image has been loaded successfully so lets put it into the DOM
          break;
        case 'loading-succeeded':// The image has successfully been loaded and placed into the DOM
          if (object) {
            object.imageFailedToLoad = false;
            object.loadOk = true;
          }
          if (image && image?.classList?.contains('d-none')) {
            image.classList.remove('d-none');
          }
          break;
        case 'loading-failed':
          // The image could not be loaded for some reason.
          // `event.data` is the error in this case
          if (object) {
            object.imageFailedToLoad = true;
          }
          if (image) {
            image.classList.add('d-none');
          }
          console.log('onStateChange loading-failed event', event);
          console.log('onStateChange loading-failed object', object);
          break;
        case 'finally': // The last event before cleaning up
          break;
      }
    } catch (error) {
      console.error('error', error);
    }
  }

}
